import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M28 4v12h12M29 4H12a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V15z"
    }, null, -1),
    _createElementVNode("g", { fill: "#000" }, [
      _createElementVNode("path", { d: "M15.799 24.398c2.345 0 3.36 1.605 3.36 3.21s-1.015 3.209-3.36 3.209h-2.14v3.181H12v-9.6zm-2.14 4.979h1.934c1.111 0 1.865-.659 1.865-1.77s-.754-1.769-1.865-1.769H13.66zM23.92 24.398c2.812 0 4.732 1.88 4.732 4.8 0 2.922-1.92 4.8-4.731 4.8h-3.483v-9.6zm-1.823 8.133h1.714c2.03 0 3.14-1.275 3.14-3.333 0-2.084-1.096-3.332-3.14-3.332h-1.714zM31.82 33.998h-1.66v-9.6h6.597v1.468H31.82v2.523h4.087v1.44H31.82z" })
    ], -1)
  ]))]))
}
export default { render: render }